import { isNumeric } from '../../util/helpers';
import { ReviewSubrating } from './review-subrating.model';

export class ReviewSummary {
  /**
   * Average of ratings for this entity
   */
  avgRating: number;

  /**
   * Number of ratings for this entity
   */
  countRatings: number;

  /**
   * Number of reviews for this entity
   */
  countReviews: number;

  /**
   * Number of reviews for this entity
   */
  avgSubRatings: Array<ReviewSubrating>;

  /**
   * Parses reviewSummary
   * @param data {any} ReviewSummary data as returned by API
   * @return {Review} Parsed reviewSummary
   */
  static parse(data: any): ReviewSummary {
    return {
      avgRating: isNumeric(data.avgRating) ? +data.avgRating : null,
      countRatings: data.countRatings,
      countReviews: data.countReviews,
      avgSubRatings: (data.avgSubRatings || []).map(d => ReviewSubrating.parse(d))
    };
  }
}
